// Translations
import landing from '../views/landing/translations/de'

// Translation: Reset (German)
export default Object.freeze({
	name: '',
	views: { landing }
})
